const MixedColumn = [
    {
        id: "desiredStatus",
        label: "status",
        style: { custom: { width: 36 } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1, pl: 0, width: "calc(100% - 402px)" } },
        disabled: true,
        checked: true,
        sortable: false,
        useInAutocomplete: true,
    },
];

export { MixedColumn };
